import OtpInput from 'react18-input-otp';

import { styled, useTheme } from '@mui/material/styles';

const BaseOtpInput = styled(OtpInput)(({ theme }) => ({
    justifyContent: 'space-around',
    '& input': {
        width: '75% !important',
        height: `${theme.spacing(7)} !important`,
        fontFamily: `${theme.typography.fontFamily} !important`,
        fontSize: `${theme.typography.h4.fontSize} !important`,
        fontWeight: 500,
        lineHeight: `${theme.spacing(4)} !important`,
        letterSpacing: 0,
        textAlign: 'center',
        borderLeft: 'none',
        borderRight: 'none',
        borderTop: 'none',
        border: `1px solid ${theme.palette.grey[300]} !important`,
        borderRadius: theme.shape.borderRadiusMd,
    },
    '& input::placeholder': { opacity: 0 },
    '& input:not(:placeholder-shown)': {
        borderColor: `${theme.palette.primary.main} !important`,
    },
    '& input:focus': {
        caretColor: theme.palette.primary.main,
    },
    '& input:focus-visible': { outline: 'none' },
}));

export interface StyledOtpInputProps {
    value: string;
    onChange: (otp: string) => void;
    hasErrored?: boolean;
}

function StyledOtpInput(props: StyledOtpInputProps) {
    const { value, onChange, hasErrored = false } = props;
    const { palette } = useTheme();

    return (
        <BaseOtpInput
            ariaLabelOverride="Enter verification code"
            autoComplete="one-time-code"
            containerStyle={{ display: 'flex', flexDirection: 'row', width: '100%' }}
            errorStyle={{ borderColor: palette.error.main }}
            hasErrored={hasErrored}
            isInputNum
            numInputs={6}
            onChange={onChange}
            placeholder="000000"
            shouldAutoFocus
            value={value}
        />
    );
}

export default StyledOtpInput;
